import { create } from 'zustand';
import id from '../i18n/id.json';
import en from '../i18n/en.json';

const dicts = { ID: id, EN: en };

/**
 * Lang state is driven by the URL prefix (/id or /en) via LangLayout.
 * The store still exists so existing useT() and setLang() call sites work
 * unchanged — LangLayout calls setLang() whenever the URL prefix changes.
 *
 * Default is EN because new visitors land on /en (root redirects there).
 */
export const useI18nStore = create((set, get) => ({
  lang: 'EN',
  setLang: (lang) => set({ lang }),
  t: (key, fallback) => {
    const dict = dicts[get().lang] || dicts.EN;
    return key.split('.').reduce((acc, k) => (acc?.[k] ?? null), dict) || fallback || key;
  }
}));

export function useT() {
  return useI18nStore((s) => s.t);
}
